<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Media object</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Media object: Example -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Example</h5>
              <p>The <a
                  href="http://www.stubbornella.org/content/2010/06/25/the-media-object-saves-hundreds-of-lines-of-code/">media
                  object</a> helps build complex and repetitive components where some media is positioned alongside
                content that doesn’t wrap around said media. Plus, it does this with only two required classes thanks to
                flexbox.</p>
              <p>Below is an example of a single media object. Only two classes are required—the wrapping <code
                  class="text-danger">.media</code> and the <code class="text-danger">.media-body</code> around your
                content. Optional padding and margin can be controlled through <a
                  href="https://getbootstrap.com/docs/4.5/utilities/spacing/">spacing utilities</a>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="media">
                    <img src="assets/images/xs/avatar1.jpg" class="me-3" alt="...">
                    <div class="media-body">
                      <h5 class="mt-0">Media heading</h5>
                      Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras
                      purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                      vulputate fringilla. Donec lacinia congue felis in faucibus.
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;media&quot;&gt;
        &lt;img src=&quot;assets/images/xs/avatar1.jpg&quot; class=&quot;me-3&quot; alt=&quot;...&quot;&gt;
        &lt;div class=&quot;media-body&quot;&gt;
            &lt;h5 class=&quot;mt-0&quot;&gt;Media heading&lt;/h5&gt;
            Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.
        &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Media object: Nesting -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Nesting</h5>
              <p>Media objects can be infinitely nested, though we suggest you stop at some point. Place nested <code
                  class="text-danger">.media</code> within the <code class="text-danger">.media-body</code> of a parent
                media object.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="media">
                    <img src="assets/images/xs/avatar2.jpg" class="me-3" alt="...">
                    <div class="media-body">
                      <h5 class="mt-0">Media heading</h5>
                      Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras
                      purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                      vulputate fringilla. Donec lacinia congue felis in faucibus.

                      <div class="media mt-3">
                        <a class="me-3" href="javascript:void(0);">
                          <img src="assets/images/xs/avatar3.jpg" class="me-3" alt="...">
                        </a>
                        <div class="media-body">
                          <h5 class="mt-0">Media heading</h5>
                          Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.
                          Cras
                          purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                          vulputate fringilla. Donec lacinia congue felis in faucibus.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;media&quot;&gt;
        &lt;img src=&quot;assets/images/xs/avatar2.jpg&quot; class=&quot;me-3&quot; alt=&quot;...&quot;&gt;
        &lt;div class=&quot;media-body&quot;&gt;
            &lt;h5 class=&quot;mt-0&quot;&gt;Media heading&lt;/h5&gt;
            Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.

            &lt;div class=&quot;media mt-3&quot;&gt;
                &lt;a class=&quot;me-3&quot; href=&quot;javascript:void(0);&quot;&gt;
                    &lt;img src=&quot;assets/images/xs/avatar3.jpg&quot; class=&quot;me-3&quot; alt=&quot;...&quot;&gt;
                &lt;/a&gt;
                &lt;div class=&quot;media-body&quot;&gt;
                    &lt;h5 class=&quot;mt-0&quot;&gt;Media heading&lt;/h5&gt;
                    Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.
                &lt;/div&gt;
            &lt;/div&gt;
        &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Media object: Alignment -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Alignment</h5>
              <p>Media in a media object can be aligned with flexbox utilities to the top (default), middle, or end of
                your <code class="text-danger">.media-body</code> content.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="media mb-3">
                    <img src="assets/images/xs/avatar4.jpg" class="align-self-start me-3" alt="...">
                    <div class="media-body">
                      <h5 class="mt-0">Top-aligned media</h5>
                      <p>Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.
                        Cras
                        purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                        vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                      <p>Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque
                        penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                    </div>
                  </div>
                  <div class="media mb-3">
                    <img src="assets/images/xs/avatar5.jpg" class="align-self-center me-3" alt="...">
                    <div class="media-body">
                      <h5 class="mt-0">Center-aligned media</h5>
                      <p>Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.
                        Cras
                        purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                        vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                      <p class="mb-0">Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum
                        sociis
                        natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                    </div>
                  </div>
                  <div class="media">
                    <img src="assets/images/xs/avatar6.jpg" class="align-self-end me-3" alt="...">
                    <div class="media-body">
                      <h5 class="mt-0">Bottom-aligned media</h5>
                      <p>Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.
                        Cras
                        purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                        vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                      <p class="mb-0">Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum
                        sociis
                        natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;media&quot;&gt;
        &lt;img src=&quot;assets/images/xs/avatar4.jpg&quot; class=&quot;align-self-start me-3&quot; alt=&quot;...&quot;&gt;
        &lt;div class=&quot;media-body&quot;&gt;
            &lt;h5 class=&quot;mt-0&quot;&gt;Top-aligned media&lt;/h5&gt;
            &lt;p&gt;Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.&lt;/p&gt;
            &lt;p&gt;Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.&lt;/p&gt;
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class=&quot;media&quot;&gt;
        &lt;img src=&quot;assets/images/xs/avatar5.jpg&quot; class=&quot;align-self-center me-3&quot; alt=&quot;...&quot;&gt;
        &lt;div class=&quot;media-body&quot;&gt;
            &lt;h5 class=&quot;mt-0&quot;&gt;Center-aligned media&lt;/h5&gt;
            &lt;p&gt;Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.&lt;/p&gt;
            &lt;p class=&quot;mb-0&quot;&gt;Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.&lt;/p&gt;
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class=&quot;media&quot;&gt;
        &lt;img src=&quot;assets/images/xs/avatar6.jpg&quot; class=&quot;align-self-end me-3&quot; alt=&quot;...&quot;&gt;
        &lt;div class=&quot;media-body&quot;&gt;
            &lt;h5 class=&quot;mt-0&quot;&gt;Bottom-aligned media&lt;/h5&gt;
            &lt;p&gt;Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.&lt;/p&gt;
            &lt;p class=&quot;mb-0&quot;&gt;Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.&lt;/p&gt;
        &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Media object: Order -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Order</h5>
              <p>Change the order of content in media objects by modifying the HTML itself, or by adding some custom
                flexbox CSS to set the <code class="text-danger">order</code> property (to an integer of your choosing).
              </p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <h5 class="mt-0 mb-1">Media object</h5>
                      Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras
                      purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                      vulputate fringilla. Donec lacinia congue felis in faucibus.
                    </div>
                    <img src="assets/images/xs/avatar6.jpg" class="ms-3" alt="...">
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;media&quot;&gt;
        &lt;div class=&quot;media-body&quot;&gt;
            &lt;h5 class=&quot;mt-0 mb-1&quot;&gt;Media object&lt;/h5&gt;
            Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.
        &lt;/div&gt;
        &lt;img src=&quot;assets/images/xs/avatar6.jpg&quot; class=&quot;ms-3&quot; alt=&quot;...&quot;&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Media object: Media list -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Media list</h5>
              <p>Because the media object has so few structural requirements, you can also use these classes on list
                HTML
                elements. On your <code class="text-danger">&lt;ul&gt;</code> or <code
                  class="text-danger">&lt;ol&gt;</code>, add the <code class="text-danger">.list-unstyled</code> to
                remove
                any browser default list styles, and then apply <code class="text-danger">.media</code> to your <code
                  class="text-danger">&lt;li&gt;</code>s. As always, use spacing utilities wherever needed to fine tune.
              </p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-unstyled">
                    <li class="media">
                      <img src="assets/images/xs/avatar7.jpg" class="me-3" alt="...">
                      <div class="media-body">
                        <h5 class="mt-0 mb-1">List-based media object</h5>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras
                        purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                        vulputate fringilla. Donec lacinia congue felis in faucibus.
                      </div>
                    </li>
                    <li class="media my-4">
                      <img src="assets/images/xs/avatar8.jpg" class="me-3" alt="...">
                      <div class="media-body">
                        <h5 class="mt-0 mb-1">List-based media object</h5>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras
                        purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                        vulputate fringilla. Donec lacinia congue felis in faucibus.
                      </div>
                    </li>
                    <li class="media">
                      <img src="assets/images/xs/avatar9.jpg" class="me-3" alt="...">
                      <div class="media-body">
                        <h5 class="mt-0 mb-1">List-based media object</h5>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras
                        purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi
                        vulputate fringilla. Donec lacinia congue felis in faucibus.
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-unstyled&quot;&gt;
        &lt;li class=&quot;media&quot;&gt;
            &lt;img src=&quot;assets/images/xs/avatar7.jpg&quot; class=&quot;me-3&quot; alt=&quot;...&quot;&gt;
            &lt;div class=&quot;media-body&quot;&gt;
                &lt;h5 class=&quot;mt-0 mb-1&quot;&gt;List-based media object&lt;/h5&gt;
                Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;media my-4&quot;&gt;
            &lt;img src=&quot;assets/images/xs/avatar8.jpg&quot; class=&quot;me-3&quot; alt=&quot;...&quot;&gt;
            &lt;div class=&quot;media-body&quot;&gt;
                &lt;h5 class=&quot;mt-0 mb-1&quot;&gt;List-based media object&lt;/h5&gt;
                Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;media&quot;&gt;
            &lt;img src=&quot;assets/images/xs/avatar9.jpg&quot; class=&quot;me-3&quot; alt=&quot;...&quot;&gt;
            &lt;div class=&quot;media-body&quot;&gt;
                &lt;h5 class=&quot;mt-0 mb-1&quot;&gt;List-based media object&lt;/h5&gt;
                Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.
            &lt;/div&gt;
        &lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
